import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { ComplexCase } from './components/sections/ComplexCase';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { SoundsFamiliar } from './components/sections/SoundsFamiliar';
import { CreatedBy } from './components/sections/CreatedBy';
import { Playbooks } from './components/sections/Playbooks';
import { ClinicalTools } from './components/sections/ClinicalTools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-navy-950 pb-24" data-id="element-0" data-mp="3mlayb9n68jv1">
      <MetaPixel data-id="element-1" data-mp="3mjzuj9tq7c3x" />
      <main className="w-full" data-id="element-2" data-mp="3mjg8bgx1m1k3">
        <Hero data-id="element-3" data-mp="3rcj31sdk3h1v" />
        <ComplexCase data-id="element-4" data-mp="3rbzo8kj7d8s2" />
        <BeforeAfter data-id="element-5" data-mp="3rdkkqfp2v1sk" />
        <SoundsFamiliar data-id="element-6" data-mp="3recedkz46pg7" />
        <CreatedBy data-id="element-7" data-mp="5osn3wyp084" />
        <Playbooks data-id="element-8" data-mp="67yhm9c7y5s" />
        <ClinicalTools data-id="element-9" data-mp="4n5w26l2pak" />
        <Bonuses data-id="element-10" data-mp="82lr78302d1" />
        <Offer data-id="element-11" data-mp="2zl39tfhhuw2o" />
        <Guarantee data-id="element-12" data-mp="2zld4hgdhhrep" />
        <Testimonials data-id="element-13" data-mp="2zm4y4lnitf2c" />
        <Author data-id="element-14" data-mp="2zmo6pbra6r3p" />
        <Faq data-id="element-15" data-mp="2zn6biws0edn8" />
        <FinalCta data-id="element-16" data-mp="33mouhn09senf" />
      </main>
      <Footer data-id="element-17" data-mp="33lwywc6oagx5" />
      <FloatingCta data-id="element-18" data-mp="33nges1of2pye" />
      <PurchasePopup data-id="element-19" data-mp="33mymth8sexwa" />
    </div>;
}